import React from "react";
import "./Footer.scss";

export default function Footer() {
  return (
    <footer className="site-footer" aria-labelledby="footer-heading">
      <div className="site-footer__inner">
        <div className="site-footer__identity">
          <p className="site-footer__eyebrow">Restons connectés</p>
          <p id="footer-heading" className="site-footer__signature">
            <span aria-hidden="true">&lt;</span>
            <span>Stéphane Simon</span>
            <span aria-hidden="true">/&gt;</span>
          </p>
          <p className="site-footer__tagline">
            Développeur intégrateur web — des solutions utiles, performantes et
            durables.
          </p>
        </div>

        <nav
          className="site-footer__navigation"
          aria-label="Liens de pied de page"
        >
          <ul className="site-footer__links">
            <li>
              <a
                className="site-footer__primary-link"
                href="https://kv2.fr"
                target="_blank"
                rel="noopener noreferrer"
              >
                Découvrir KV2
                <span className="sr-only"> (nouvelle fenêtre)</span>
                <span aria-hidden="true">↗</span>
              </a>
            </li>
            <li>
              <a href="#/mentions-legales">Mentions légales</a>
            </li>
            <li>
              <a href="#/confidentialite">Confidentialité et cookies</a>
            </li>
            <li>
              <a href="#/accessibilite">Accessibilité</a>
            </li>
          </ul>
        </nav>

        <p className="site-footer__copyright">
          © {new Date().getFullYear()} KV2 · Tous droits réservés
        </p>
      </div>
    </footer>
  );
}
